import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import numWords from "num-words";
import ToUpper from "../ToUpper";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.NC001.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) culverts at the following river stations are added
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.NC002.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) culverts at the following river stations are removed
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.NC003.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) bridges at the following river stations are added
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.NC004.error_id: {
            return (
                <>
                    <ResultText>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) bridges at the following river stations are removed
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.NC005.error_id: {
            return (
                <>
                    <div>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) inline structures at the following river stations are added
                    </div>
                    <div>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </div>
                </>
            )
        }
        case MessageCodes.Compare.NC006.error_id: {
            return (
                <>
                    <div>
                        {ToUpper(numWords(row?.data?.length))} ({row?.data?.length}) inline structures at the following river stations are removed
                    </div>
                    <div>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </div>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const C3 = {
    RenderDescription,
}